export default 'icon--link';